import { NavLink } from 'react-router-dom'
import { LayoutDashboard, Calendar, Users, Settings, BookOpen } from 'lucide-react'
import Icon from '@mdi/react'
import { mdiBaseball } from '@mdi/js'
import { cn } from '@/utils/cn'

const tabs = [
  { to: '/dashboard', label: 'Home',     icon: LayoutDashboard },
  { to: '/schedule',  label: 'Schedule', icon: Calendar },
  { to: '/pitching',  label: 'Pitching', icon: null, mdiPath: mdiBaseball },
  { to: '/roster',    label: 'Roster',   icon: Users },
  { to: '/rules',     label: 'Rules',    icon: BookOpen },
  { to: '/settings',  label: 'Settings', icon: Settings },
]

export function BottomNav() {
  return (
    <nav className="md:hidden fixed bottom-0 inset-x-0 bg-white border-t border-gray-200 z-30 safe-bottom">
      <div className="flex">
        {tabs.map(({ to, label, icon: LucideIcon, mdiPath }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              cn(
                'flex-1 flex flex-col items-center justify-center gap-0.5 py-2 text-[10px] font-medium transition-colors',
                isActive ? 'text-brand-600' : 'text-gray-500',
              )
            }
          >
            {LucideIcon
              ? <LucideIcon className="h-5 w-5" />
              : <Icon path={mdiPath!} size={0.85} />
            }
            {label}
          </NavLink>
        ))}
      </div>
    </nav>
  )
}
